import {useContext} from 'react'
import {DimensionsContext} from './dimensions-context'
import {Dimensions} from './types/dimensions'

export function useDimensions(): Dimensions {
    return useContext(DimensionsContext)
}
